import mrGroup from '../../../images/components/Customers/gallery/mr-group.svg';
import sminex from '../../../images/components/Customers/gallery/sminex.svg';
import samolet from '../../../images/components/Customers/gallery/samolet.svg';

const gallery = [{ image: mrGroup }, { image: sminex }, { image: samolet }];

export default gallery;
